import React from 'react';

function LoadingContent() {
    return (
        <div className="login-container d-flex align-items-center justify-content-center" style={{background: 'url(/waves-white.png)'}}>
            <div className="loading-container card-loading">
                <img src="/logo.png" style={{width: '150px', marginBottom: '10px'}} className="logo-login-top" alt="GeoTrace"/>
                <div className="spinner"></div>
            </div>
        </div>
    )
}

export default LoadingContent;